<template>
  <nav class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme shadow-sm no-print" id="layout-navbar">
    
    <!-- زر القائمة للجوال (يحافظ على دالة addCalss) -->
    <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
      <a class="nav-item nav-link px-0 me-xl-4" @click="addCalss" href="javascript:void(0)">
        <i class="bx bx-menu bx-sm text-primary"></i>
      </a>
    </div>

    <div class="navbar-nav-right d-flex align-items-center justify-content-between w-100" id="navbar-collapse">
      
      <!-- 1. القسم الأيمن: شعار الشركة والوقت (توقيت القاهرة) -->
      <div class="navbar-nav align-items-center">
        <div class="nav-item d-flex align-items-center bg-light px-3 py-1 rounded-pill border time-wrapper">
          <img :src="'../img/com.jpg'" alt="logo" class="rounded-circle me-2 navbar-logo" />
          <div class="d-flex flex-column clock-container">
            <span class="text-danger fw-bold fs-6">{{ time }}</span>
            <small class="text-muted clock-subtext">توقيت القاهرة</small>
          </div>
        </div>
      </div>

      <!-- 2. القسم الأوسط: اسم الموقع الحالي (ديناميكي) -->
      <div class="d-none d-md-block text-center flex-grow-1 px-3">
          <div class="site-badge">
             <i class="bx bx-map-pin text-success me-1"></i>
             <span class="fw-bold text-dark">{{ admin.site?.site_name || 'مركز التحكم الرئيسي' }}</span>
          </div>
      </div>

      <!-- 3. القسم الأيسر: الإشعارات وبروفايل المستخدم -->
      <ul class="navbar-nav flex-row align-items-center ms-auto">
        
        <!-- التنبيهات (Notification) -->
        <li class="nav-item navbar-dropdown dropdown-user dropdown me-3">
          <a class="nav-link dropdown-toggle hide-arrow position-relative" href="javascript:void(0);" data-bs-toggle="dropdown">
            <div class="btn-icon bg-light rounded-circle shadow-xs">
               <i class="bx bx-bell fs-4 text-secondary"></i>
               <span class="badge bg-danger badge-dot border-white"></span>
            </div>
          </a>
          <ul class="dropdown-menu dropdown-menu-end shadow-lg border-0 mt-3 custom-dropdown">
            <li class="p-3 text-center small text-muted">لا توجد تنبيهات جديدة حالياً</li>
          </ul>
        </li>

        <!-- ملف المستخدم (User Profile) -->
        <li class="nav-item navbar-dropdown dropdown-user dropdown">
          <a class="nav-link dropdown-toggle hide-arrow p-0 d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="dropdown">
            <div class="user-meta text-end me-2 d-none d-sm-block">
                <span class="fw-bold text-dark d-block user-name-line">{{ admin.name }}</span>
                <small class="text-muted">{{ admin.admin == 1 ? 'مدير النظام' : 'مستخدم' }}</small>
            </div>
            <div class="avatar avatar-online border border-2 border-primary p-1 bg-white rounded-circle shadow-sm">
              <img :src="'img/user.png'" alt="user" class=" h-auto rounded-circle" />
            </div>
          </a>
          
          <!-- قائمة الخيارات المنسدلة -->
          <ul class="dropdown-menu dropdown-menu-end shadow-lg border-0 mt-3 custom-dropdown">
            <li>
              <div class="dropdown-item py-3">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-3">
                    <div class="avatar avatar-online border rounded-circle p-1">
                      <img :src="'img/user.png'" alt="user" class="h-auto rounded-circle" />
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <span class="fw-bold d-block lh-1">{{ admin.name }}</span>
                    <small class="text-muted">{{ admin.admin == 1 ? 'Administrator' : 'General User' }}</small>
                  </div>
                </div>
              </div>
            </li>
            <li><div class="dropdown-divider"></div></li>
            <!-- <li>
              <router-link to="/Settings" class="dropdown-item py-2">
                <i class="bx bx-user me-2 text-primary"></i>
                <span class="align-middle">الملف الشخصي</span>
              </router-link>
            </li>
            <li>
              <router-link to="/Settings" class="dropdown-item py-2">
                <i class="bx bx-cog me-2 text-info"></i>
                <span class="align-middle">إعدادات النظام</span>
              </router-link>
            </li> -->
            <li><div class="dropdown-divider"></div></li>
            <li>
              <a @click="Logout" class="dropdown-item py-2 text-danger fw-bold" href="javascript:void(0);">
                <i class="bx bx-power-off me-2"></i>
                <span class="align-middle">تسجيل الخروج</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>

    </div>
  </nav>
</template>

<script>
import moment from 'moment-timezone';
import User from '@/apis/User';

export default {
  data() {
    return {
      time: ''
    }
  },
  created() {
    // تحديث الساعة كل ثانية
    this.updateClock();
    setInterval(() => {
      this.updateClock();
    }, 1000);
  },
  computed: {
    admin() {
      return this.$store.state.user;
    }
  },
  methods: {
    updateClock() {
      this.time = moment().tz("Africa/Cairo").format("hh:mm A");
    },
    Logout() {
      User.logout().then(res => {
        localStorage.removeItem("user");
        localStorage.removeItem("auth");
        localStorage.removeItem("token");
        this.$toastr.s("تم تسجيل الخروج بنجاح", "وداعاً");
        this.$router.push({ path: "/login" });
      })
    },
    addCalss() {
      const html = document.getElementsByTagName("html")[0];
      html.classList.add('light-style', 'layout-menu-fixed', 'layout-menu-expanded');
    },
  },
}
</script>

<style scoped>
/* تنسيقات CSS نقية (Plain CSS) */

.bg-navbar-theme {
    background-color: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(10px);
}

.layout-navbar {
    border-radius: 12px !important;
    margin-top: 10px !important;
    height: 70px;
}

.time-wrapper {
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.navbar-logo {
    width: 32px; 
    height: 32px;
}

.clock-container {
    line-height: 1.1;
}

.clock-subtext {
    font-size: 0.7rem;
}

.site-badge {
    background: #f0f2f4;
    padding: 8px 20px;
    border-radius: 50px;
    display: inline-block;
    border: 1px solid #e1e4e8;
}

.btn-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    cursor: pointer;
}

.btn-icon:hover {
    background: #eceeff !important;
}

.user-name-line {
    line-height: 1;
}

.avatar-online {
    position: relative;
}

/* علامة الأونلاين (النقطة الخضراء) */
.avatar-online::after {
    content: '';
    position: absolute;
    bottom: 2px;
    right: 3px;
    width: 10px;
    height: 10px;
    background: #71dd37;
    border: 2px solid #fff;
    border-radius: 50%;
}

.custom-dropdown {
    border-radius: 12px !important;
    padding: 10px;
}

.dropdown-item {
    border-radius: 8px;
    margin-bottom: 2px;
}

.dropdown-item:hover {
    background-color: #f5f6ff !important;
}

.badge-dot {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 8px;
    height: 8px;
    padding: 0;
}
/* .h-auto {
    height: unset !important;
}
.w-px-40 {
    width: unset !important;
} */
/* إخفاء الناف بار في الطباعة */
@media print {
    .no-print { 
        display: none !important; 
    }
}
</style>